import React from 'react';
import { ShieldCheckIcon, ZapIcon, CreditCardIcon, LockIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BuyButton } from './ui/BuyButton';
export function FinalCta() {
  return <section className="w-full bg-sage-deep py-20 text-cream sm:py-28" data-id="element-84" data-mp="19f7dr2t0u9cb">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-85" data-mp="15dlumzpw8yto">
        <Reveal data-id="element-86" data-mp="15c2d75si4hqb">
          <p className="text-sm font-semibold uppercase tracking-widest text-cream/70" data-id="element-87" data-mp="15fq8oahibe7o">
            Decisión final
          </p>
          <h2 className="mt-3 font-serif text-3xl font-semibold sm:text-4xl lg:text-5xl" data-id="element-88" data-mp="1eek1rqvmpmgh">
            El próximo lunes podés volver a improvisar la clase
          </h2>
          <p className="mx-auto mt-5 max-w-xl leading-relaxed text-cream/80" data-id="element-89" data-mp="1t4rahevu3r3z">
            O podés entrar al estudio con todo resuelto desde hoy. Yoga 360 te da estructura,
            clases, posturas, secuencias, adaptaciones, planificación y recursos
            profesionales para enseñar con más seguridad durante todo el año.
          </p>

          <div className="mt-9 flex flex-col items-center" data-id="element-90" data-mp="n6dzj6dcrpoz">
            <span className="text-sm text-cream/60 line-through" data-id="element-91" data-mp="s4pchpyy2gbf">Precio anterior: $69.990</span>
            <span className="mt-1 font-serif text-6xl font-semibold text-cream" data-id="element-92" data-mp="s6ij559k50jf">$27.990</span>
            <span className="mt-3 inline-block rounded-full bg-clay px-4 py-1.5 text-sm font-semibold text-cream" data-id="element-93" data-mp="x64z3mgrsuvx">
              Oferta única de lanzamiento
            </span>
          </div>

          <div className="mt-9 flex flex-col items-center" data-id="element-94" data-mp="162dwkvl6tjff">
            <BuyButton className="w-full sm:w-auto" data-id="element-95" data-mp="1b2i5o0jrnbvm">Comprar ahora y empezar hoy</BuyButton>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-cream/75" data-id="element-96" data-mp="1fu07srxizii6">
              <span className="inline-flex items-center gap-1.5" data-id="element-97" data-mp="1ks1q3an4ndsl">
                <LockIcon className="h-4 w-4" data-id="element-98" data-mp="1pszfa76k183l" /> Pago seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-99" data-mp="1tu17w55yulwl">
                <ZapIcon className="h-4 w-4" data-id="element-100" data-mp="1tuavjm3jggz4" /> Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-101" data-mp="3qvgpnwhf0bax">
                <ShieldCheckIcon className="h-4 w-4" data-id="element-102" data-mp="3lw44rha3teaz" /> Garantía 7 días
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-103" data-mp="3hcvtof87p5n">
                <CreditCardIcon className="h-4 w-4" data-id="element-104" data-mp="3jpkekfhoxro" /> Mercado Pago
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}